<template>
  <div :class="['check-field', { checked, disabled, required: showRequired }]" @click="toggle">
    <FriedIcon icon="check-mark" class="check-icon" />
  </div>
</template>
<script lang="ts">
import type { Field } from '@getaccept/lib-shared/src/fields/types/field';
import { defineComponent, computed, watch } from 'vue';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'CheckboxField',
  props: {
    field: { type: Object as PropType<Field>, required: true },
    disabled: { type: Boolean, required: true },
    pressSpace: { type: Boolean, required: true },
  },
  emits: ['update'],
  setup(props, { emit }) {
    watch(
      () => props.pressSpace,
      press => {
        if (press) {
          toggle();
        }
      }
    );

    const checked = computed(() => !!parseInt(props.field.value));
    const showRequired = computed(() => {
      if (props.disabled) {
        return false;
      }
      return props.field.isRequired;
    });

    const toggle = () => {
      if (!props.disabled) {
        emit('update', checked.value ? '' : '1');
      }
    };

    return {
      checked,
      showRequired,
      toggle,
    };
  },
});
</script>
<style lang="scss" scoped>
.check-field {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  :deep(.check-icon) {
    transition: opacity linear 0.1s;
    opacity: 1;
    height: 80%;
    width: 80%;
  }

  &:not(.checked) {
    :deep(.check-icon) {
      opacity: 0;
    }
  }

  &.disabled {
    &:not(.checked) {
      background: var(--field-gray-background);
    }
  }

  &.required::after {
    color: var(--error-dark);
    font-size: 1.7em;
    content: '*';
    position: absolute;
    right: -0.75em;
    top: 0.5em;
  }
}
</style>
